<template>
	<div class="sub-header">
		<spinner v-if="profile.loading"/>
		<div v-else-if="profile.data" class="profile">
			<avatar-picture-watch :user_uid="user_uid" :watch_id="watch_id" :watch="watch"/>
			<div class="body">
				<div class="information">
					<div class="name">{{ profile.data.name }}</div>
					<div class="age"><span>{{ age }}</span> {{ $t('labels.general.years_old') }}</div>
				</div>
				<div class="details">
					<div class="detail address" v-if="addresses && addresses.length">
						<svgicon name="geo fencing" :fill="false" class="small-icon"></svgicon>
						<div>
							<div v-for="contact in addresses" :key="contact.id">{{ contact.contact }}</div>
						</div>
					</div>
					<div class="detail birthday">
						<svgicon name="birthday" :fill="false" class="small-icon"></svgicon>
						<span>{{ profile.data.birthday | formatDate(vue) }}</span>
					</div>
					<div class="detail diseases" v-if="profile && profile.data && profile.data.diseases && profile.data.diseases.length">
						<svgicon name="star of life" :fill="false" class="small-icon"></svgicon>
						<div>
							<div v-for="disease in profile.data.diseases" :key="disease.id">{{ $t('categories.diseases.'+disease.name.replace(/ /g, '_').replace(/'/g, '´').toLowerCase()) }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="!profile.loading && profile.data" class="btn-group-subheader">
			<button @click="openMenu" class="btn-subheader mobile">
				<svgicon :name="btnIcon" :fill="false"/>
			</button>
			<options :user_uid="user_uid" :watch_id="watch_id" @click.native="closeMenu" class="btn-subheader"/>
		</div>
	</div>
</template>

<script>
import Options from './options/WatchOptions'
import AvatarPictureWatch from '@/components/avatars/AvatarPictureWatch'
export default {
	components: {
		Options,
		AvatarPictureWatch
	},
	props: [
		'user_uid',
		'watch_id',
		'watch',
		'profile'
	],
	data () {
		return {
			vue: this
		}
	},
	computed: {
		addresses () {
			let result = []
			if (this.profile.data && this.profile.data.contacts) {
				result = this.profile.data.contacts.filter(element => element.type == 'address')
			}
			return result
		},
		age () {
			return this.$moment().diff(this.profile.data.birthday, 'years', false) // false for no fraction values
		},
		btnIcon () {
			return this.open ? 'closing' : 'menu'
		}
	},
	methods: {
		openMenu () {
			this.$root.$emit('open-submenu')
		},
		closeMenu () {
			this.$root.$emit('close-submenu') //only used to prevent both options and menu being open at same time
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/SubHeader.vue